<template>
    <div ref="dibujo" class="dibujo" style="width: 98%">
        <canvas
            ref="myCanvas"
            id="myCanvas"
            width="560"
            height="560"
            @touchstart="beginDrawing"
            @touchmove="keepDrawing"
            @touchend="stopDrawing"
            @touchcancel="
                (e) => {
                    e.preventDefault();
                }
            "
            @mousedown="beginDrawing"
            @mousemove="keepDrawing"
            @mouseup="stopDrawing"
        />
        <div class="draw-foot">
            <v-row dense>
                <v-col
                    cols="4"
                    sm="2"
                    md="2"
                    style="display: flex; justify-content: space-evenly"
                >
                    <div
                        @click="erase"
                        ref="eraser"
                        :class="`draw-button ${
                            index == 0 ? 'selected-draw' : ''
                        }`"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                        >
                            <title>eraser</title>
                            <path
                                d="M16.24,3.56L21.19,8.5C21.97,9.29 21.97,10.55 21.19,11.34L12,20.53C10.44,22.09 7.91,22.09 6.34,20.53L2.81,17C2.03,16.21 2.03,14.95 2.81,14.16L13.41,3.56C14.2,2.78 15.46,2.78 16.24,3.56M4.22,15.58L7.76,19.11C8.54,19.9 9.8,19.9 10.59,19.11L14.12,15.58L9.17,10.63L4.22,15.58Z"
                            />
                        </svg>
                    </div>
                    <div
                        @click="write"
                        :class="`draw-button ${
                            index == 1 ? 'selected-draw' : ''
                        }`"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                        >
                            <title>pencil</title>
                            <path
                                d="M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z"
                            />
                        </svg>
                    </div>
                    <div
                        @click="texto()"
                        :class="`draw-button ${
                            index == 3 ? 'selected-draw' : ''
                        }`"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                        >
                            <path
                                d="M18.5,4L19.66,8.35L18.7,8.61C18.25,7.74 17.79,6.87 17.26,6.43C16.73,6 16.11,6 15.5,6H13V16.5C13,17 13,17.5 13.33,17.75C13.67,18 14.33,18 15,18V19H9V18C9.67,18 10.33,18 10.67,17.75C11,17.5 11,17 11,16.5V6H8.5C7.89,6 7.27,6 6.74,6.43C6.21,6.87 5.75,7.74 5.3,8.61L4.34,8.35L5.5,4H18.5Z"
                            />
                        </svg>
                    </div>
                </v-col>
                <v-col cols="4" sm="3" md="2">
                    <v-select :items="sizes" dense outlined v-model="width">
                    </v-select>
                </v-col>
                <v-col cols="4" sm="2" md="2">
                    <colorSelect v-model="color"></colorSelect>
                </v-col>
                <v-col sm="2" cols="4" md="2">
                    <v-btn color="green" text-white @click="dialog = true"
                        >Guardar</v-btn
                    >
                </v-col>
                <v-col cols="5" sm="6" md="4">
                    <v-text-field
                        dense
                        outlined
                        label="Texto"
                        v-model="text"
                    ></v-text-field>
                </v-col>
                <v-col cols="3" sm="4" md="2">
                    <v-select
                        dense
                        :items="sizes_text"
                        outlined
                        v-model="width_text"
                    >
                    </v-select>
                </v-col>
            </v-row>
        </div>
        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Guardar audio
                </v-card-title>
                <v-card-text style="text-align: center"
                    ><v-row>
                        <v-col cols="12"> </v-col>
                        <v-col cols="12">
                            <v-text-field
                                label="Nombre Archivo"
                                v-model="nombre_archivo"
                            ></v-text-field>
                        </v-col> </v-row
                ></v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>

                    <v-btn color="success" large @click="save()">Guardar</v-btn>

                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<style scoped>
.v-input__slot::before {
    border-style: none !important;
}
.draw-button {
    border-radius: 9999999px;
    height: 2.6rem;
    width: 2.6rem;
    padding: 0.2rem;
    color: black;
}
.selected-draw {
    background-color: grey;
}
.draw-foot {
    display: flex;
    border-top: 0.4rem solid grey;
    padding-top: 0.25rem;
    height: 100%;
    width: 100%;
}
.dibujo {
    border: 0.4rem solid grey;

    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
}
</style>
<script>
import colorSelect from "../../../components/general/colorSelect.vue";
export default {
    components: {
        colorSelect,
    },
    props: ["id_presupuesto"],
    data() {
        return {
            dialog: false,
            nombre_archivo: "dibujo",
            sizes: [1, 5, 10, 15, 20, 25, 30],
            sizes_text: [10, 15, 20, 25, 30],

            x: 0,
            y: 0,
            color: "#000000",
            width: 1,
            isDrawing: false,
            canvas: null,
            index: 1,
            text: "",
            width_text: 25,
            stopity: false,
        };
    },
    created() {
        window.addEventListener("resize", this.getWidth);
    },

    destroyed() {
        window.removeEventListener("resize", this.getWidth);
    },

    methods: {
        addText(x, y) {
            let ctx = this.canvas;
            //console.log(x);
            const text = this.text;
            ctx.font = `${this.width_text}px Arial`;
            ctx.fillStyle = this.color;
            ctx.fillText(text, x, y);
        },
        save() {
            //console.log();
            this.$emit("save", {
                data: this.$refs.myCanvas.toDataURL(),
                nombre: this.nombre_archivo,
                extension: "png",
                callback: () => {
                    const ctx = this.$refs.myCanvas.getContext("2d");

                    // Set the fill color to white
                    ctx.fillStyle = "#FFFFFF";
                    // Fill the canvas with the white color
                    ctx.fillRect(
                        0,
                        0,
                        this.$refs.myCanvas.width,
                        this.$refs.myCanvas.height
                    );
                },
            });
        },
        erase() {
            this.index = 0;
        },
        texto() {
            this.index = 3;
        },
        write() {
            this.color = "black";

            this.index = 1;
        },
        getWidth() {
            if (this.$refs.dibujo.clientWidth == this.$refs.myCanvas.width) {
                return;
            }
            this.$refs.myCanvas.width = this.$refs.dibujo.clientWidth;
            const ctx = this.$refs.myCanvas.getContext("2d");

            // Set the fill color to white
            ctx.fillStyle = "#ffffff";

            // Fill the canvas with the white color
            ctx.fillRect(
                0,
                0,
                this.$refs.myCanvas.width,
                this.$refs.myCanvas.height
            );
        },
        drawLine(x1, y1, x2, y2) {
            let ctx = this.canvas;
            ctx.beginPath();
            ctx.strokeStyle = this.index == 0 ? "white" : this.color;
            ctx.lineWidth = this.width;
            ctx.lineCap = "round";

            ctx.moveTo(x1, y1);
            ctx.lineTo(x2, y2);
            ctx.stroke();
            ctx.closePath();
        },
        beginDrawing(e) {
            this.x = e.offsetX;
            this.y = e.offsetY;
            if (e.touches != null) {
                var touch = e.touches[0]; // Get the first touch event

                const canvas = e.target;
                const rect = canvas.getBoundingClientRect();
                this.x = e.touches[0].clientX - rect.left;
                this.y = e.touches[0].clientY - rect.top;

                //console.log("X:", this.x, "Y:", this.y);
            }
            if (this.index == 3) {
                this.addText(this.x, this.y);
                this.stopity = false;
            } else {
                this.isDrawing = true;
            }

            e.preventDefault();
        },
        keepDrawing(e) {
            //console.log(e);
            if (this.isDrawing === true) {
                let offsetX = 0;
                let offsetY = 0;
                if (e.type == "touchmove") {
                    const canvas = e.target;
                    const rect = canvas.getBoundingClientRect();
                    offsetX = e.touches[0].clientX - rect.left;
                    offsetY = e.touches[0].clientY - rect.top;
                } else {
                    offsetX = e.offsetX;
                    offsetY = e.offsetY;
                }
                this.drawLine(this.x, this.y, offsetX, offsetY);
                this.x = offsetX;
                this.y = offsetY;
            } else {
                if (this.stopity == false) {
                    let offsetX = 0;
                    let offsetY = 0;
                    if (e.type == "touchmove") {
                        const canvas = e.target;
                        const rect = canvas.getBoundingClientRect();
                        offsetX = e.touches[0].clientX - rect.left;
                        offsetY = e.touches[0].clientY - rect.top;
                    } else {
                        offsetX = e.offsetX;
                        offsetY = e.offsetY;
                    }
                    this.stopity = true;
                    this.addText(this.offsetX, this.offsetY);
                }
            }
            e.preventDefault();
        },
        stopDrawing(e) {
            if (this.isDrawing === true) {
                this.drawLine(this.x, this.y, e.offsetX, e.offsetY);
                this.x = 0;
                this.y = 0;
                this.isDrawing = false;
            }
            e.preventDefault();
        },
    },
    mounted() {
        var c = document.getElementById("myCanvas");
        this.canvas = c.getContext("2d");
        this.getWidth();
    },
};
</script>
